import { CaseDto, DataBlockDto, VisitDto } from '@lmt/shared-types';

export enum CaseTreeItemType {
  addContent = 'add',
  showStatus = 'status',
  empty = 'empty',
  transportStatus = 'transportStatus',
}

export enum CaseItemType {
  visit = 'visit',
  measurement = 'measurement',
  caseData = 'case-data',
}

export enum SubCaseItemType {
  measurement = 'measurement',
  caseInfo = 'case-info',
  visitInfo = 'visit-info',
  visitPreview = 'visitPreview',
}

export type CaseItem = {
  id: string;
  date: Date;
  type: CaseItemType;
  showStatistic?: boolean;
  isStatisticCompleted?: boolean;
} & (
  | {
      type: CaseItemType.measurement;
      item: DataBlockDto;
      subitems: SubCaseItem[];
      isGDTEnabled: boolean;
      isHL7Enabled: boolean;
      transportInfo?: TransportInfo;
    }
  | {
      type: CaseItemType.visit;
      item: VisitDto;
      subitems: SubCaseItem[];
    }
  | {
      type: CaseItemType.caseData;
      item: CaseDto;
      subitems: SubCaseItem[];
    }
);

export type SubCaseItem = {
  id: string;
  date: Date;
  type: SubCaseItemType;
  item: DataBlockDto;
  isGDTEnabled?: boolean;
  isHL7Enabled?: boolean;
  isNotDeletable?: boolean;
  transportInfo?: TransportInfo;
  showStatistic?: boolean;
  isStatisticCompleted?: boolean;
};

export enum TransportStatus {
  progress = 'progress',
  success = 'success',
  error = 'error',
}

export type TransportInfo = {
  isHL7: boolean;
  isGDT: boolean;
} & (
  | {
      isHL7: true;
      hl7Status: TransportStatus;
      hl7Date: Date;
    }
  | {
      isHL7: false;
    }
) &
  (
    | {
        isGDT: true;
        gdtStatus: TransportStatus;
        gdtDate: Date;
      }
    | {
        isGDT: false;
      }
  );

export type ChannelKey = 'hl7' | 'gdt' | 'email';
export const CHANNEL_LABEL: Record<ChannelKey, string> = {
  hl7: 'HL7',
  gdt: 'GDT',
  email: 'E-mail',
};

export enum StatusKey {
  Successful = 'successful',
  Failed = 'failed',
  InProcess = 'in_process',
}

export enum StatusDateKey {
  SuccessfulAt = 'successful_at',
  FailedAt = 'failed_at',
  InProcessSince = 'in_process_since',
}
